const palette = {
  grey100: '#e0e0e0',
  grey200: '#aeaeb1',
  grey300: '#7c7c81',
  grey400: '#666666',
  grey600: '#00023f',
  grey700: '#181b31',
  placeholder: '#000000',
};

const colors = {
  active: palette.placeholder,
  black: '#000000',
  currentSession: '#000000',
  error: '#fc4c6c',
  form: palette.placeholder,
  homeAuto: palette.placeholder,
  hover: palette.grey300,
  info: '#000000',
  mortgage: palette.placeholder,
  primary: '#000000',
  realEstate: palette.placeholder,
  savings: palette.placeholder,
  secondary: palette.grey700,
  splashBackground: '#F5F5F5',
  splashPlanet: '#C4C4D2',
  splashRing: '#C4C4D2',
  splashSun: '#1D1D23',
  text: '#000000',
  textDark: palette.grey600,
  textDarker: '#000000',
  transparentPrimary: palette.placeholder,
  white: '#ffffff',
};

export {
  palette, colors,
};
